import {
    AllEvents,
    ArticleLikePublication,
    isArticle,
} from '@news-mono/web-common'
import React from 'react'
import { LazyGeneralInArticleBanner } from '../../../banners/GenericInArticleBanner'
import {
    InlineContentTypes,
    InlineCourtsNCrimesBanner,
} from '../SharedPublication.routing'

export interface getInlinePositionedGeneralBannerProps {
    publication: ArticleLikePublication
    inlinePublicationContent: InlineContentTypes[]
    onEvent: (event: AllEvents) => void
}

export function isInlineCourtsNCrimesBanner(
    content: InlineContentTypes,
): content is InlineCourtsNCrimesBanner {
    return content.kind === 'inline-courts-n-crimes-banner'
}

export function getInlinePositionedCourtsNCrimesBanner({
    publication,
    inlinePublicationContent,
    onEvent,
}: getInlinePositionedGeneralBannerProps) {
    if (!isArticle(publication)) {
        return []
    }

    const validTopics = ['news/court-justice', 'news/crime', 'news/police']

    if (
        !validTopics.includes(publication.primaryTopic.id) &&
        !publication.secondaryTopics.find((topic) =>
            validTopics.includes(topic.id),
        )
    ) {
        return []
    }

    return inlinePublicationContent
        .filter(isInlineCourtsNCrimesBanner)
        .map((content: InlineCourtsNCrimesBanner) => {
            return {
                position: content.insertAfter,
                element: (
                    <LazyGeneralInArticleBanner
                        onEvent={onEvent}
                        heading={content.props.heading}
                        subText={content.props.subText}
                        buttonText={content.props.buttonText}
                        driverLink={content.props.driverLink}
                        color={content.props.color}
                        feature={content.props.feature}
                        hasBottomMargin={true}
                    />
                ),
            }
        })
}
